import React, { useState } from "react";
import { Button, Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import TableLayout from "../../../components/TableLayout";
import { CstmPagination } from "../../../components/Common/Common";
import { Link } from "react-router-dom";
import {
  useGetOrderQuery,
  useGetOrderExportFileMutation,
} from "../../../store/services/orderService";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import { type } from "@testing-library/user-event/dist/cjs/utility/index.js";
import styles from "./Details/details.module.scss";

const ORDER_TYPE = {
  MEAL: 1,
  PRODUCT: 2,
  BOTH: 3,
};

const StoreOrderManagement = () => {
  const [bodyData, setBodyData] = useState({
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    pageNo: 1,
    status: "",
    type: [2, 3], // Default to meal plan (both product and both types)
    search: "",
  });

  const { data: order, isLoading } = useGetOrderQuery(bodyData);
  console.log("order===>>>>", order);

  const [dateRange, setDateRange] = useState([null, null]);
  const [error, setError] = useState("");
  const [Loading, setLoading] = useState(false);
  const [startDate, endDate] = dateRange;

  const handleDateChange = (update) => {
    setError("");
    if (update[0] && update[1]) {
      const diffDays = moment(update[1]).diff(moment(update[0]), "days");

      if (diffDays <= 6) {
        setDateRange(update);
        setBodyData((prevState) => ({
          ...prevState,
          startDate: moment(update[0])
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          endDate: moment(update[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
        }));
      } else {
        //  alert("Please select a date range of up to 7 days.");
        //setDateRange([update[0], null]); // Reset endDate if range exceeds 7 days
        setError("Please select a date range of up to 7 days.");
      }
    } else {
      setDateRange(update);
      setBodyData((prevState) => ({
        ...prevState,
        startDate: "",
        endDate: "",
      }));
    }
  };

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        const startingIndex = (bodyData.pageNo - 1) * bodyData.limit; // Calculate starting index based on pageNo and limit
        const serialNumber = startingIndex + key + 1; // Calculate serial number based on key and starting index

        return <>{serialNumber < 10 ? `0${serialNumber}` : serialNumber}</>;
      },
    },

    {
      head: "Customer Name",
      accessor: "customerName",
      component: (item, key, arr) => (
        // <p className="m-0 themeBlue fw-sbold">{item.orderID}</p>
        <p className="m-0 themeBlue fw-sbold">
          {item?.user?.firstName} {item?.user?.lastName}
        </p>
      ),
    },
    {
      head: "Order ID",
      accessor: "orderID",
      component: (item, key, arr) => (
        // <p className="m-0 themeBlue fw-sbold">{item.orderID}</p>
        <p className="m-0 themeBlue fw-sbold">
          {item.orderID ? item.orderID : "N/A"}
        </p>
      ),
    },
    {
      head: "Meal Plan",
      accessor: "type",
      component: (item, key, arr) => {
        const type = item?.type;
        let displayText = "N/A";

        if (type === 2) {
          displayText = "No";
        } else if (type === 3) {
          displayText = "Yes";
        }

        return <p className="m-0 themeBlue fw-sbold">{displayText}</p>;
      },
    },
    {
      head: "Start Date",
      accessor: "startDate",
      component: (item, key, arr) => {
        if (item?.type === 2) {
          return <span>N/A</span>;
        }
        return <>{moment(item.startDate).format("DD/MM/YYYY")}</>;
      },
    },

    {
      head: "Status",
      accessor: "status",
      component: (item, key, arr) => (
        <>
          {(() => {
            let statusText;
            if (item.status === "confirmed") {
              statusText = <span className="text-green">Confirmed</span>;
            } else if (item.status === "delivered") {
              statusText = <span className="text-red">Delivered</span>;
            } else {
              statusText = <span className="text-gray">{item?.status}</span>;
            }
            return statusText;
          })()}
        </>
      ),
    },
    {
      head: "Actions",
      accessor: "Action",
      component: (item, key, arr) => (
        <div className="actionBtn d-flex align-items-center gap-10">
          <Link
            to={`/store-order-details/${item?._id}/all`}
            className="border-0 p-0"
            variant="transparent"
            title="view"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="13"
              viewBox="0 0 21 13"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.1269 0.379883C6.00023 0.379883 2.81476 3.30125 1.26883 5.0114C0.614598 5.73509 0.23969 6.2714 0.23969 6.2714C0.0900251 6.48573 0.0900251 6.77233 0.23969 6.98666C0.23969 6.98666 0.534721 7.40936 1.05152 8.0024C2.50253 9.6674 5.79632 12.8782 10.1269 12.8782C14.572 12.8782 17.9291 9.49839 19.3181 7.87307C19.7642 7.35098 20.0152 6.98666 20.0152 6.98666C20.1649 6.77233 20.1649 6.48573 20.0152 6.2714C20.0152 6.2714 19.7398 5.87467 19.2535 5.31173C17.8276 3.6621 14.5055 0.379883 10.1269 0.379883ZM10.1269 1.62996C13.8634 1.62996 16.9827 4.59581 18.3074 6.12852C18.5725 6.43529 18.5974 6.48424 18.7089 6.63143C18.605 6.76803 18.593 6.79697 18.3671 7.06124C17.0781 8.56964 13.9201 11.6281 10.1269 11.6281C6.43137 11.6281 3.34181 8.72873 1.99268 7.18081C1.70294 6.8484 1.67185 6.78672 1.55443 6.63143C1.69037 6.45001 1.77636 6.31473 2.19543 5.85135C3.63536 4.25828 6.60534 1.62996 10.1269 1.62996ZM10.1269 2.88004C8.06297 2.88004 6.38027 4.56274 6.38027 6.62663C6.38027 8.69036 8.06297 10.378 10.1269 10.378C12.1906 10.378 13.8783 8.69036 13.8783 6.62663C13.8783 4.56274 12.1906 2.88004 10.1269 2.88004ZM10.1269 4.13127C11.5152 4.13127 12.6282 5.23814 12.6282 6.62663C12.6282 8.01496 11.5152 9.12794 10.1269 9.12794C8.73837 9.12794 7.6315 8.01496 7.6315 6.62663C7.6315 5.23814 8.73837 4.13127 10.1269 4.13127Z"
                fill="#645C5C"
                title="View"
              />
            </svg>
          </Link>

          {item?.status === "delivered" && (
            <button
              className="border-0 p-0 bg-transparent"
              title="Copy Survey Link"
              onClick={() => {
                const surveyLink = `https://www.kalofy.com/survey/${item?._id}`;
                navigator.clipboard
                  .writeText(surveyLink)
                  .then(() => {
                    toast.success("Survey link copied!");
                  })
                  .catch((err) => {
                    toast.error("Failed to copy link");
                    console.error("Failed to copy: ", err);
                  });
              }}
            >
              {/* Simple Copy SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M10 1.5A1.5 1.5 0 0 1 11.5 3v1h-1V3a.5.5 0 0 0-.5-.5h-7A.5.5 0 0 0 2.5 3v7a.5.5 0 0 0 .5.5h1v1h-1A1.5 1.5 0 0 1 1 10.5v-7A1.5 1.5 0 0 1 2.5 2h7z" />
                <path d="M5 5.5A1.5 1.5 0 0 1 6.5 4h7A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 5 12.5v-7zM6.5 5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7z" />
              </svg>
            </button>
          )}
        </div>
      ),
    },
  ];
  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);

  const handlePageChange = (selectedPage) => {
    setBodyData((prevState) => ({
      ...prevState,
      pageNo: selectedPage.selected + 1, // Update the page numbers (selected is 0-based index)
    }));
  };

  const [exportUsers, { isLoading: isExporting }] =
    useGetOrderExportFileMutation();

  const exportHandler = async () => {
    setLoading(true);
    try {
      const data = await exportUsers({ ...bodyData, csv: true }).unwrap();

      if (data.status_code === 200) {
        const downloadUrl = data.data;

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "export.csv");
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Failed to export users:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // const exportHandler = async () => {
  //   try {
  //     const data = await exportUsers({
  //       limit: 10,
  //       orderBy: "createdAt",
  //       order: -1,
  //       pageNo: 1,
  //       status: "",
  //       search: "",
  //     //  startDate: "",
  //      // endDate: "",
  //       csv: true,
  //     }).unwrap();

  //     if (data.status_code === 200) {
  //       const downloadUrl = data.data; // Assuming data.data contains the file URL

  //       // Create an invisible link element
  //       const link = document.createElement("a");
  //       link.href = downloadUrl;
  //       link.setAttribute("download", "export.csv"); // Set a filename for download
  //       link.style.display = "none";

  //       // Append the link to the body, click it to initiate the download, then remove it
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     }
  //   } catch (error) {
  //     console.error("Failed to export users:", error); // Handle error
  //   }
  // };

  // const exportHandler = async () => {
  //   setLoading(true);
  //   try {
  //     const data = await exportUsers({
  //       limit: 10,
  //       orderBy: "createdAt",
  //       order: -1,
  //       pageNo: 1,
  //       status: "",
  //       search: "",
  //       // startDate: "",
  //       // endDate: "",
  //       csv: true,
  //     }).unwrap();
  //     if (data.status_code === 200) {
  //       const downloadUrl = data.data; // Assuming data.data contains the files URL

  //       // Create an invisible link element
  //       const link = document.createElement("a");
  //       link.href = downloadUrl;
  //       link.setAttribute("download", ""); // Use this to prompt download
  //       link.style.display = "none";

  //       // Append the link to the body, click it to initiate the download, then remove it
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     }
  //   } catch (error) {
  //     console.error("Failed to delete the meal:", error); // Handle error
  //   } finally {
  //     setLoading(false); // Stop loading
  //   }
  // };
  const options = [
    { value: "confirmed", label: "Confirmed" },
    { value: "delivered", label: "Delivered" },
    { value: "cancelled", label: "Cancelled" },
    // { value: "onTheWay", label: "On the way" },
    { value: "paused", label: "Paused" },
    // Uncomment this if need
    // { value: "swapped", label: "Swapped" },
  ];

  const productTypeOptions = [
    {
      value: "yes",
      label: "Yes",
      typeValue: [ORDER_TYPE.BOTH],
    },
    { value: "no", label: "No", typeValue: [ORDER_TYPE.PRODUCT] },
  ];

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setBodyData((prev) => ({ ...prev, status: selectedValue }));
  };

  const handleProductTypeChange = (event) => {
    const selectedValue = event.target.value;

    if (!selectedValue) {
      // If no option is selected, show all types (both product and both types)
      setBodyData((prev) => ({
        ...prev,
        type: [ORDER_TYPE.PRODUCT, ORDER_TYPE.BOTH],
        pageNo: 1,
      }));
      return;
    }

    const selectedOption = productTypeOptions.find(
      (option) => option.value === selectedValue
    );

    if (selectedOption) {
      setBodyData((prev) => ({
        ...prev,
        type: selectedOption.typeValue,
        pageNo: 1, // Reset to first page when filter changes
      }));
    }
  };
  return (
    <>
      <ConfirmationPop
        confirmation={confirmation}
        setConfirmation={setConfirmation}
      />
      <section className="orderManagement position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Store Order Management
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                                         <li className="">
                       <div className="searchBox position-relative iconWithText">
                         <Button
                           className="border-0 p-0 position-absolute icn"
                           variant="transparent"
                           style={{ right: 10 }}
                         >
                           <svg
                             xmlns="http://www.w3.org/2000/svg"
                             width="19"
                             height="19"
                             viewBox="0 0 19 19"
                             fill="none"
                           >
                             <path
                               d="M18.2462 17.225L13.1462 12.125C14.1212 10.925 14.7212 9.35 14.7212 7.625C14.7212 3.725 11.4962 0.5 7.59619 0.5C3.69619 0.5 0.471191 3.725 0.471191 7.625C0.471191 11.525 3.69619 14.75 7.59619 14.75C9.32119 14.75 10.8212 14.15 12.0962 13.175L17.1962 18.275C17.3462 18.425 17.5712 18.5 17.7212 18.5C17.8712 18.5 18.0962 18.425 18.2462 18.275C18.5462 17.975 18.5462 17.525 18.2462 17.225ZM7.59619 13.25C4.52119 13.25 1.97119 10.7 1.97119 7.625C1.97119 4.55 4.52119 2 7.59619 2C10.6712 2 13.2212 4.55 13.2212 7.625C13.2212 10.7 10.6712 13.25 7.59619 13.25Z"
                               fill="#C4C4C4"
                             />
                           </svg>
                         </Button>
                         {bodyData.search && (
                           <Button
                             className="border-0 p-0 position-absolute"
                             variant="transparent"
                             style={{ right: 35, top: '50%', transform: 'translateY(-50%)' }}
                             onClick={() => {
                               setBodyData((prevState) => ({
                                 ...prevState,
                                 search: "",
                                 pageNo: 1,
                               }));
                             }}
                             title="Clear search"
                           >
                             <svg
                               xmlns="http://www.w3.org/2000/svg"
                               width="14"
                               height="14"
                               viewBox="0 0 24 24"
                               fill="none"
                               stroke="#666"
                               strokeWidth="2"
                               strokeLinecap="round"
                               strokeLinejoin="round"
                             >
                               <line x1="18" y1="6" x2="6" y2="18"></line>
                               <line x1="6" y1="6" x2="18" y2="18"></line>
                             </svg>
                           </Button>
                         )}
                         <input
                           type="text"
                           placeholder="Search Order ID"
                           className="form-control"
                           value={bodyData.search}
                           onChange={(e) =>
                             setBodyData((prevState) => ({
                               ...prevState,
                               search: e.target.value,
                               pageNo: 1,
                             }))
                           }
                         />
                       </div>
                     </li>

                    <li>
                      <div className={styles.quantitySelectWrapper}>
                        <select
                          id="status"
                          className={styles.quantitySelect}
                          onChange={handleChange}
                          defaultValue=""
                        >
                          <option value="">Select status</option>
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </li>
                    <li>
                      <div className={styles.quantitySelectWrapper}>
                        <select
                          id="productType"
                          className={styles.quantitySelect}
                          onChange={handleProductTypeChange}
                          defaultValue=""
                        >
                          <option value="">Select meal plan</option>
                          {productTypeOptions?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        disabled={Loading} // Disable button while loading
                        onClick={exportHandler}
                      >
                        {Loading ? "Exporting..." : "Export CSV"}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="Confirmed"
              >
                <div className="my-2 pt-3">
                  {/* <TableLayout column={column} data={data} />
                  <CstmPagination /> */}
                  {isLoading && (
                    <div className="text-center">
                      <div className="spinner-border text-dark" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  )}
                  {!isLoading && order?.data?.length > 0 && (
                    <TableLayout column={column} data={order?.data} />
                  )}
                  {!isLoading && order?.data?.length === 0 && (
                    <div
                      className="text-center d-flex align-items-center justify-content-center rounded-3"
                      style={{ border: "1px dashed #ddd", minHeight: 400 }}
                    >
                      <h4 className="m-0">No data Found</h4>
                    </div>
                  )}
                  {order?.data?.length > 0 && (
                    <CstmPagination
                      pageCount={order?.totalcount / bodyData.limit}
                      onPageChange={handlePageChange}
                      itemsPerPage={bodyData.limit}
                      totalItems={order?.totalcount}
                      currentPage={bodyData?.pageNo}
                    />
                  )}
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default StoreOrderManagement;
